import image1 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image1.webp';
import image4 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image4.webp';
import image6 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image6.webp';
import image7 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image7.webp';
import image8 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image8.webp';
import image10 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image10.webp';
import image13 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image13.webp';
import image14 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image14.webp';
import image15 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image15.webp';
import image17 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image17.webp';
import image19 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image19.webp';
import image24 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image24.webp';
import image25 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image25.webp';
import image26 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image26.webp';
import image27 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image27.webp';
import image28 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image28.webp';
import image29 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image29.webp';
import image30 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image30.webp';
import image31 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image31.webp';
import image32 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image32.webp';
import image33 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image33.webp';
import image34 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image34.webp';
import image35 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image35.webp';
import image36 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image36.webp';
import image37 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image37.webp';
import image38 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image38.webp';
import image39 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image39.webp';
import image40 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image40.webp';
import image41 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image41.webp';
import image42 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image42.webp';
import image43 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image43.webp';
import image44 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image44.webp';
import image45 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image45.webp';
import image49 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image49.webp';
import image52 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image52.webp';
import image53 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image53.webp';
import image54 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image54.webp';
import image55 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image55.webp';
import image56 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image56.webp';
import image57 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image57.webp';
import image60 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image60.webp';
import image62 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image62.webp';
import image64 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image64.webp';
import image65 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image65.webp';
import image66 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image66.webp';
import image67 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image67.webp';
import image68 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image68.webp';
import image69 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image69.webp';
import image70 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image70.webp';
import image71 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image71.webp';
import image72 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image72.webp';
import image73 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image73.webp';
import image74 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image74.webp';
import image75 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image75.webp';
import image76 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image76.webp';
import image77 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image77.webp';
import image78 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image78.webp';
import image79 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image79.webp';
import image80 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image80.webp';
import image81 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image81.webp';
import image82 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image82.webp';
import image83 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image83.webp';
import image84 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image84.webp';
import image85 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image85.webp';
import image86 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image86.webp';
import image87 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image87.webp';
import image88 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image88.webp';
import image89 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image89.webp';
import image90 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image90.webp';
import image91 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image91.webp';
import image92 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image92.webp';
import image93 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image93.webp';
import image94 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image94.webp';
import image95 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image95.webp';
import image96 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image96.webp';
import image97 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image97.webp';
import image98 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image98.webp';
import image99 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image99.webp';
import image100 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image100.webp';
import image101 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image101.webp';
import image102 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image102.webp';
import image103 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image103.webp';
import image104 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image104.webp';
import image105 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image105.webp';
import image106 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image106.webp';
import image107 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image107.webp';
import image108 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image108.webp';
import image109 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image109.webp';
import image110 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image110.webp';
import image111 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image111.webp';
import image112 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image112.webp';
import image113 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image113.webp';
import image114 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image114.webp';
import image115 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image115.webp';
import image116 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image116.webp';
import image117 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image117.webp';
import image118 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image118.webp';
import image119 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image119.webp';
import image120 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image120.webp';
import image121 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image121.webp';
import image122 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image122.webp';
import image123 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image123.webp';
import image124 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image124.webp';
import image125 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image125.webp';
import image127 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image127.webp';
import image128 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image128.webp';
import image129 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image129.webp';
import image130 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image130.webp';
import image131 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image131.webp';
import image132 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image132.webp';
import image133 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image133.webp';
import image134 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image134.webp';
import image135 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image135.webp';
import image136 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image136.webp';
import image137 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image137.webp';
import image138 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image138.webp';
import image139 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image139.webp';
import image140 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image140.webp';
import image141 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image141.webp';
import image142 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image142.webp';
import image143 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image143.webp';
import image144 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image144.webp';
import image145 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image145.webp';
import image146 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image146.webp';
import image147 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image147.webp';
import image148 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image148.webp';
import image149 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image149.webp';
import image150 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image150.webp';
import image151 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image151.webp';
import image152 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image152.webp';
import image153 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image153.webp';
import image154 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image154.webp';
import image155 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image155.webp';
import image156 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image156.webp';
import image157 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image157.webp';
import image158 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image158.webp';
import image159 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image159.webp';
import image160 from '../../../../../assets/Images/Highlights/LanguageDept/2024-2025/Image160.webp';



export const yearTwentyTwentyFourFive = [
  image1,
  image4,
  image6,
  image7,
  image8,
  image10,
  image13,
  image14,
  image15,
  image17,
  image19,
  image24,
  image25,
  image26,
  image27,
  image28,
  image29,
  image30,
  image31,
  image32,
  image33,
  image34,
  image35,
  image36,
  image37,
  image38,
  image39,
  image40,
  image41,
  image42,
  image43,
  image44,
  image45,
  image49,
  image52,
  image53,
  image54,
  image55,
  image56,
  image57,
  image60,
  image62,
  image64,
  image65,
  image66,
  image68,
  image69,
  image71,
  image72,
  image73,
  image75,
  image67,
  image74,
  image70,
  image78,
  image79,
  image80,
  image81,
  image82,
  image83,
  image76,
  image77,
  image94,
  image90,
  image84,
  image86,
  image87,
  image88,
  image85,
  image89,
  image91,
  image92,
  image93,
  image95,
  image96,
  image97,
  image98,
  image99,
  image100,
  image101,
  image102,
  image103,
  image104,
  image105,
  image106,
  image107,
  image108,
  image109,
  image110,
  image111,
  image117,
  image112,
  image113,
  image114,
  image115,
  image116,
  image118,
  image119,
  image120,
  image121,
  image122,
  image123,
  image124,
  image125,
  image127,
  image128,
  image129,
  image130,
  image131,
  image132,
  image133,
  image134,
  image135,
  image136,
  image137,
  image138,
  image139,
  image140,
  image141,
  image142,
  image143,
  image144,
  image145,
  image146,
  image147,
  image148,
  image149,
  image150,
  image151,
  image152,
  image153,
  image154,
  image155,
  image156,
  image157,
  image158,
  image159,
  image160
]
